import { StateType as SessionManagerStateType } from '@central-products/interface-session-manager';
import { AccountInfoStateType } from '@central-products/interface-account-info';
import { publish, subscribe } from '@wh/message-bus';
import { isNative, isUserAgent } from '../../utils';
import { ANDROID_SPAIN_SPORTSBOOK_NATIVE_APP_USER_AGENT } from '../../constants';

function subscribeForStateChange(feature, callback) {
  let unsubscribe = feature.onStateChanged(callback);
  // do not await for result because it blocks from returning unsubscribe which expected in the callback
  // eslint-disable-next-line promise/catch-or-return, promise/no-callback-in-promise
  feature.getState().then(callback);
  return () => {
    if (unsubscribe === null) {
      return;
    }

    unsubscribe();
    unsubscribe = null;
  };
}

function waitForSession() {
  const features = WH.bootstrapper.features;
  return new Promise((resolve) => {
    const sessionManagerUnsubscribe = subscribeForStateChange(features['session-manager'], ({ state }) => {
      if (state === SessionManagerStateType.UNKNOWN) {
        return;
      }
      sessionManagerUnsubscribe();
      if (state === SessionManagerStateType.NOT_LOGGED_IN) {
        features['login-flow'].start();
      }
    });

    const accInfoUnsub = subscribeForStateChange(features['account-info'], ({ state }) => {
      if (state === AccountInfoStateType.ACCOUNT_INFO_EXISTS) {
        accInfoUnsub();
        resolve();
      }
    });
  });
}

function openMyAccountView(viewUrlParam, params = {}) {
  if (params.legacyMarketingConsentDeepLinkBehavior && viewUrlParam === 'personalDetailsMarketing') {
    publish('wh.myAccount.command.dropdown.open', { path: '/PersonalDetails/Marketing' });
    return;
  }
  publish('wh.myAccount.command.dropdown.open', {
    path: viewUrlParam,
  });
}

export const myAccountViewFromMessagebusPlugin = {
  beforeBootstrap() {
    subscribe({
      topic: 'wh.myAccount.command.myAccountView.open',
      callback: async ({ data }) => {
        if (!data || !data.myAccountView) {
          return;
        }

        if (!isNative() || isUserAgent(ANDROID_SPAIN_SPORTSBOOK_NATIVE_APP_USER_AGENT)) {
          await waitForSession();
        }

        openMyAccountView(data.myAccountView, data.params);
      },
    });
  },
};
